/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  InvitePatientUserRequestDto,
  InviteProviderUserRequestDto,
  LearningRedirectResponseDto,
  PracticeBranchResponseDto,
  PracticeProfileDetailDto,
  PracticeProfileUpdateDto,
  PracticeUsersResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InvitePatientUserRequestDtoFromJSON,
    InvitePatientUserRequestDtoToJSON,
    InviteProviderUserRequestDtoFromJSON,
    InviteProviderUserRequestDtoToJSON,
    LearningRedirectResponseDtoFromJSON,
    LearningRedirectResponseDtoToJSON,
    PracticeBranchResponseDtoFromJSON,
    PracticeBranchResponseDtoToJSON,
    PracticeProfileDetailDtoFromJSON,
    PracticeProfileDetailDtoToJSON,
    PracticeProfileUpdateDtoFromJSON,
    PracticeProfileUpdateDtoToJSON,
    PracticeUsersResponseDtoFromJSON,
    PracticeUsersResponseDtoToJSON,
} from '../models/index';

export interface DeletePracticeUserRequest {
    userId: string;
}

export interface GetPracticeProfileByUserIdRequest {
    userId: string;
    includeRxntCredentials?: boolean;
}

export interface InvitePatientUserRequest {
    invitePatientUserRequestDto: InvitePatientUserRequestDto;
}

export interface InviteProviderUserRequest {
    inviteProviderUserRequestDto: InviteProviderUserRequestDto;
}

export interface ListPracticeUsersRequest {
    search?: string;
    role?: ListPracticeUsersRoleEnum;
    status?: ListPracticeUsersStatusEnum;
    branchId?: string;
    sortBy?: ListPracticeUsersSortByEnum;
    sortOrder?: ListPracticeUsersSortOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface ListPracticeUsersForAdminRequest {
    search?: string;
    role?: ListPracticeUsersForAdminRoleEnum;
    status?: ListPracticeUsersForAdminStatusEnum;
    branchId?: string;
    sortBy?: ListPracticeUsersForAdminSortByEnum;
    sortOrder?: ListPracticeUsersForAdminSortOrderEnum;
    page?: number;
    pageSize?: number;
    practiceId?: string;
}

export interface ResendPatientInvitationRequest {
    patientId: string;
}

export interface ResendProviderInvitationRequest {
    providerId: string;
}

export interface UpdatePracticeUserRequest {
    userId: string;
    practiceProfileUpdateDto: PracticeProfileUpdateDto;
}

/**
 * 
 */
export class PracticeUsersApi extends runtime.BaseAPI {

    /**
     * Delete a user from the practice
     * Delete practice user
     */
    async deletePracticeUserRaw(requestParameters: DeletePracticeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deletePracticeUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user from the practice
     * Delete practice user
     */
    async deletePracticeUser(requestParameters: DeletePracticeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePracticeUserRaw(requestParameters, initOverrides);
    }

    /**
     * Generate SSO URL to redirect user to LearnWorlds if onboarding is complete and subscription is valid
     * Get learning redirect URL
     */
    async getLearningRedirectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearningRedirectResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/learning/redirect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearningRedirectResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generate SSO URL to redirect user to LearnWorlds if onboarding is complete and subscription is valid
     * Get learning redirect URL
     */
    async getLearningRedirect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearningRedirectResponseDto> {
        const response = await this.getLearningRedirectRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all branches for the practice
     * Get practice branches
     */
    async getPracticeBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PracticeBranchResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PracticeBranchResponseDtoFromJSON));
    }

    /**
     * Get all branches for the practice
     * Get practice branches
     */
    async getPracticeBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PracticeBranchResponseDto>> {
        const response = await this.getPracticeBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get practice profile by user ID
     */
    async getPracticeProfileByUserIdRaw(requestParameters: GetPracticeProfileByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeProfileDetailDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getPracticeProfileByUserId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeRxntCredentials'] != null) {
            queryParameters['includeRxntCredentials'] = requestParameters['includeRxntCredentials'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeProfileDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get practice profile by user ID
     */
    async getPracticeProfileByUserId(requestParameters: GetPracticeProfileByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeProfileDetailDto> {
        const response = await this.getPracticeProfileByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite a patient to the practice. Creates patient user, FHIR resource, and establishes active data sharing automatically.
     * Invite patient user
     */
    async invitePatientUserRaw(requestParameters: InvitePatientUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['invitePatientUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'invitePatientUserRequestDto',
                'Required parameter "invitePatientUserRequestDto" was null or undefined when calling invitePatientUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/patients/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvitePatientUserRequestDtoToJSON(requestParameters['invitePatientUserRequestDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invite a patient to the practice. Creates patient user, FHIR resource, and establishes active data sharing automatically.
     * Invite patient user
     */
    async invitePatientUser(requestParameters: InvitePatientUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.invitePatientUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite a provider to the practice
     * Invite provider user
     */
    async inviteProviderUserRaw(requestParameters: InviteProviderUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['inviteProviderUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'inviteProviderUserRequestDto',
                'Required parameter "inviteProviderUserRequestDto" was null or undefined when calling inviteProviderUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/providers/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteProviderUserRequestDtoToJSON(requestParameters['inviteProviderUserRequestDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invite a provider to the practice
     * Invite provider user
     */
    async inviteProviderUser(requestParameters: InviteProviderUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.inviteProviderUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List users within the caller\'s practice with search, sort, filter, and pagination.
     * List practice users
     */
    async listPracticeUsersRaw(requestParameters: ListPracticeUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeUsersResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['branchId'] != null) {
            queryParameters['branchId'] = requestParameters['branchId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeUsersResponseDtoFromJSON(jsonValue));
    }

    /**
     * List users within the caller\'s practice with search, sort, filter, and pagination.
     * List practice users
     */
    async listPracticeUsers(requestParameters: ListPracticeUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeUsersResponseDto> {
        const response = await this.listPracticeUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin-scoped list of practice users across all practices or filtered by a specific practiceId, with search, sort, filter, and pagination.
     * Admin list practice users
     */
    async listPracticeUsersForAdminRaw(requestParameters: ListPracticeUsersForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeUsersResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['branchId'] != null) {
            queryParameters['branchId'] = requestParameters['branchId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/admin/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeUsersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Admin-scoped list of practice users across all practices or filtered by a specific practiceId, with search, sort, filter, and pagination.
     * Admin list practice users
     */
    async listPracticeUsersForAdmin(requestParameters: ListPracticeUsersForAdminRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeUsersResponseDto> {
        const response = await this.listPracticeUsersForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend an invitation to a patient
     * Resend patient invitation
     */
    async resendPatientInvitationRaw(requestParameters: ResendPatientInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling resendPatientInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/patients/{patientId}/resend-invitation`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resend an invitation to a patient
     * Resend patient invitation
     */
    async resendPatientInvitation(requestParameters: ResendPatientInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.resendPatientInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend an invitation to a provider
     * Resend provider invitation
     */
    async resendProviderInvitationRaw(requestParameters: ResendProviderInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['providerId'] == null) {
            throw new runtime.RequiredError(
                'providerId',
                'Required parameter "providerId" was null or undefined when calling resendProviderInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/provider/{providerId}/resend-invitation`.replace(`{${"providerId"}}`, encodeURIComponent(String(requestParameters['providerId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resend an invitation to a provider
     * Resend provider invitation
     */
    async resendProviderInvitation(requestParameters: ResendProviderInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.resendProviderInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user in the practice
     * Update practice user
     */
    async updatePracticeUserRaw(requestParameters: UpdatePracticeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeProfileDetailDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updatePracticeUser().'
            );
        }

        if (requestParameters['practiceProfileUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'practiceProfileUpdateDto',
                'Required parameter "practiceProfileUpdateDto" was null or undefined when calling updatePracticeUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-users/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PracticeProfileUpdateDtoToJSON(requestParameters['practiceProfileUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeProfileDetailDtoFromJSON(jsonValue));
    }

    /**
     * Update a user in the practice
     * Update practice user
     */
    async updatePracticeUser(requestParameters: UpdatePracticeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeProfileDetailDto> {
        const response = await this.updatePracticeUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListPracticeUsersRoleEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Staff: 'staff',
    Admin: 'admin'
} as const;
export type ListPracticeUsersRoleEnum = typeof ListPracticeUsersRoleEnum[keyof typeof ListPracticeUsersRoleEnum];
/**
 * @export
 */
export const ListPracticeUsersStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type ListPracticeUsersStatusEnum = typeof ListPracticeUsersStatusEnum[keyof typeof ListPracticeUsersStatusEnum];
/**
 * @export
 */
export const ListPracticeUsersSortByEnum = {
    AccountId: 'accountId',
    Email: 'email',
    Name: 'name',
    PhoneNumber: 'phoneNumber',
    Npi: 'npi',
    AddedDate: 'addedDate'
} as const;
export type ListPracticeUsersSortByEnum = typeof ListPracticeUsersSortByEnum[keyof typeof ListPracticeUsersSortByEnum];
/**
 * @export
 */
export const ListPracticeUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListPracticeUsersSortOrderEnum = typeof ListPracticeUsersSortOrderEnum[keyof typeof ListPracticeUsersSortOrderEnum];
/**
 * @export
 */
export const ListPracticeUsersForAdminRoleEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Staff: 'staff',
    Admin: 'admin'
} as const;
export type ListPracticeUsersForAdminRoleEnum = typeof ListPracticeUsersForAdminRoleEnum[keyof typeof ListPracticeUsersForAdminRoleEnum];
/**
 * @export
 */
export const ListPracticeUsersForAdminStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type ListPracticeUsersForAdminStatusEnum = typeof ListPracticeUsersForAdminStatusEnum[keyof typeof ListPracticeUsersForAdminStatusEnum];
/**
 * @export
 */
export const ListPracticeUsersForAdminSortByEnum = {
    AccountId: 'accountId',
    Email: 'email',
    Name: 'name',
    PhoneNumber: 'phoneNumber',
    Npi: 'npi',
    AddedDate: 'addedDate'
} as const;
export type ListPracticeUsersForAdminSortByEnum = typeof ListPracticeUsersForAdminSortByEnum[keyof typeof ListPracticeUsersForAdminSortByEnum];
/**
 * @export
 */
export const ListPracticeUsersForAdminSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListPracticeUsersForAdminSortOrderEnum = typeof ListPracticeUsersForAdminSortOrderEnum[keyof typeof ListPracticeUsersForAdminSortOrderEnum];
